import defaultTheme from './default';
import type { ICheckoutTheme } from './types/ICheckout';

export const CheckoutTheme: ICheckoutTheme = {
  ...defaultTheme,

  widthPercentageOfInput: '48.5%',
};
